import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListDE = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaDE.socialmediaListDE);
    const [socialmediaListDE, setSocialmedialListDE] = useState(s);
    const loading = useSelector(state => state.socialmediaDE.loading);
    const e = useSelector(state => state.socialmediaDE.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaDE.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.DEUTSCH_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListDE}
            setSocialmedialList={setSocialmedialListDE}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}